import React from 'react';
import { Button } from './ui/button';
import { Zap } from 'lucide-react';

const CTASection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-600/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600/20 border border-blue-500/30 rounded-full text-blue-400 text-sm font-medium backdrop-blur-sm mb-6">
          <Zap className="w-4 h-4" />
          Innovative Technology Solutions
        </div>
        
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight pb-2">
          Transform Your Business with
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 pb-2">
            Cutting-Edge Technology
          </span>
        </h2>
        
        <p className="text-lg sm:text-xl text-slate-300 mb-10 leading-relaxed max-w-2xl mx-auto">
          Learn more about how our solutions can help your business, whether it's for specific technology 
          or comprehensive IT and telecoms infrastructure support.
        </p>
        
        <Button
          onClick={scrollToContact}
          size="lg"
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-10 py-7 text-lg rounded-lg shadow-2xl shadow-blue-600/40 hover:shadow-blue-600/60 transition-all hover:scale-105"
        >
          CONTACT US TODAY
        </Button>
      </div>
    </section>
  );
};

export default CTASection;